import protectedAxios from '../auth/axios.js';
import { mapState, mapGetters , mapMutations } from 'vuex';

export const poistenieMixin = {
  props: {
    value: Object,
    dataId: String,
    cisloPredmetu: Number,
    newId: String,
    select: {
      type: Function,
      default: () => { },
    },
    sumar: {
      type: Number,
      default: 0,
    },
    addButton: Boolean,
    isSelected: {
      type: Boolean,
      default: false
    },
    isOlfs:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      poistovne: new Map(),
      toolTipMessage: '',
      tooltipData: [],
      detailDialog:false
    };
  },
  computed: {
    ...mapState(['pripad']),
    ...mapGetters(['jeDealer','dialog','isMobile']),
  },
  methods: {
    ...mapMutations(['openDialog', 'closeDialog']),
    addButtonClicked() {
      this.$emit('addButtonClicked', this.value.valueMember);
    },
    modifyOnEvent(onEvent, valueMember) {
      //chyti vuetify on event pre tooltip a prida do neho volanie metody onHelpHover
      let oldEvent = onEvent.mouseenter;
      onEvent.mouseenter = () => {
        this.onHelpHover(valueMember);
        oldEvent();
      };
      return onEvent;
    },
    openDetailDialog(poistenie) {
      let textDetail = '';
      textDetail += ``;
      let text = `<div class="pb-5"><span class="detail-header">${poistenie.displayMember}</span><br/><span>Načítavam... </span></div>
          ${textDetail}`;
      let _dialog = {
        persistent: true,
        width: '576',
        header: `Detail poistenia`,
        closeIcon: {
          value: true,
        },
        textClass: ['pripoistenie'],
        text: text,
      };

      this.openDialog(_dialog);
      // this.detailDialog = true;
      // this.detailData = [];
      // this.detailMessage = 'Načítavam... ';
      protectedAxios
        .get(
          `controls/poistenieinfo?ViewObjectId=${this.dataId}&NewId=${
            this.newId ?? ''
          }&CisloPredmetu=${this.cisloPredmetu ?? ''}&Typ=${poistenie.valueMember ?? ''}&Sumar=${this.sumar}`
        )
        .then(res => {
          textDetail = '';
          let mobileRowClass = this.isMobile ? " pb-3" : ""
          let subheaderRowClass = "detail-name"
          let mobileDetailNameClass = this.isMobile ? "col-12 py-0" : "col col-7 py-2";
          let subheaderDetailNameClass = "detail-name"
          let detailValueClass = this.isMobile ? "col-12 py-0 detail-value" : "col col-5 py-2 detail-value";
          for (let i = 0; i < res.data.length; i++) {
            let subheader = res.data[i].hodnota == null || res.data[i].hodnota == "";
            subheaderRowClass = subheader == true ? 'pt-3' : '';
            subheaderDetailNameClass = subheader == true ? 'detail-subheader' : 'detail-name';
            textDetail += `
              <div class="row ${mobileRowClass} ${subheaderRowClass}">
                <div class="${mobileDetailNameClass} ${subheaderDetailNameClass}">${res.data[i].popis}</div>
                <div class="${detailValueClass}">${res.data[i].hodnota}</div>
              </div>`;
          }
          text = `<div class="pb-5"><span class="detail-header">${poistenie.displayMember}</span></div>
          ${textDetail}`;
          _dialog.text = text;
          this.openDialog(_dialog);
          // this.detailMessage = '';
          // this.detailData = res.data;
        })
        .catch(e => {
          console.error(this.dataId, e);
          if(e?.onlyInterceptor)
            return;
          textDetail += ``;
          text = `<div class="pb-5"><span class="detail-header">${poistenie.displayMember}</span><span>Chyba pri načítaní.</span></div>
          ${textDetail}`;
          _dialog.text = text;
          this.openDialog(_dialog);
          // this.detailMessage = 'Chyba pri načítaní.';
        });
    },
    onHelpHover(valueMember) {
      this.tooltipData = [];
      this.toolTipMessage = 'Načítavam... ';
      protectedAxios
        .get(
          `controls/poistenieinfo?ViewObjectId=${this.dataId
          }&NewId=${this.newId ?? ''}&CisloPredmetu=${this.cisloPredmetu ?? ''
          }&Typ=${valueMember ?? ''}&Sumar=${this.sumar}`
        )
        .then(res => {
          this.toolTipMessage = '';
          this.tooltipData = res.data;
        })
        .catch(e => {
          console.error(this.dataId, e);
          this.toolTipMessage = 'Chyba pri načítaní.';
          if(e?.onlyInterceptor)
            return;
        });
    },
    getImage(item) {
      let key = this.poistovne.get(item.id_poistovne?.toString());
      if (key) {
        if (item.id_poistovne === 84814 || item.id_poistovne === 46)
          return require(`../assets/img/${key}${!this.$vuetify.theme.dark ? '-dark' : ''}.png`);
        else
          return require(`../assets/img/${key}.png`);
      } else {
        return require(`../assets/img/no_image.png`);
      }
    },
    handleSelect() {
      if (!this.pripad.predmetZamknuty) this.select();
    },
  },
  created() {
    this.poistovne.set('48', 'uniqa');
    this.poistovne.set('45', 'kooperativa');
    this.poistovne.set('44', 'komunalna');
    this.poistovne.set('42', 'generali');
    this.poistovne.set('41', 'allianz');
    this.poistovne.set('93', 'defend');
    this.poistovne.set('46', 'union');
    this.poistovne.set('84814', 'colonnade');
  },
};
